<template>
  <div class="checkbox hide-for-print" :class="checkboxClasses" @click.stop="toggle()">
    <span v-if="reverse" class="checkbox__label"><slot></slot></span>
    <svg v-if="active === false" class="checkbox__off" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><path class="cls-1" d="M9,1V9H1V1H9m.2-1H.8A.8.8,0,0,0,0,.8V9.2a.8.8,0,0,0,.8.8H9.2a.8.8,0,0,0,.8-.8V.8A.8.8,0,0,0,9.2,0Z"/></g></g></svg>
    <svg v-else class="checkbox__on" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><rect class="cls-1" width="10" height="10" rx="0.8" ry="0.8"/><polyline class="cls-2" points="2.15 4.96 4.27 7.01 7.89 2.98"/></g></g></svg>
    <span v-if="!reverse" class="checkbox__label"><slot></slot></span>
  </div>
  <!-- /.checkbox -->
</template>

<script>
export default {
  name: 'checkbox',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    active: {
      type: Boolean,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkboxClasses () {
      let cls = {
        'checkbox--reverse': this.reverse
      }
      cls[ 'checkbox--' + this.type ] = true
      return cls
    }
  },
  methods: {
    toggle () {
      this.$emit('toggle')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';
  @import '~@/components/sass/shared/helpers';

  .checkbox__on,
  .checkbox__off{
    height: 10px;
    margin-right: 5px;
    width: 10px;
  }

  .checkbox--reverse {
    .checkbox__on,
    .checkbox__off {
      margin-left: 5px;
    }
  }

  .checkbox__off{
    .cls-1{
      fill:#bec4cc;
    }
  }

  .checkbox__on{
    .cls-1{
      fill:#2f3e5e;
    }
    .cls-2{
      fill:none;
      stroke:#fff;
      stroke-linejoin:round;
    }
  }

  .checkbox--covid19 {
    background: $white;
    border-radius: 3px;
    overflow: hidden;
    font-size: 0;
    line-height: 0;

    .checkbox__on,
    .checkbox__off {
      height: 15px;
      width: 15px;
      margin: 0;
    }

    .checkbox__off .cls-1 { fill: $white; }

    .checkbox__on .cls-1 { fill:$white; }
    .checkbox__on .cls-2 { stroke:$covid19; }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/misc/Checkbox.vue